import classNames from "classnames";
import { utc } from "PFCore/helpers/date";

import { CalendarSelectProps } from "../calendar.types";
import css from "./month_selector.module.scss";
import { Months } from "./months";
import { Years } from "./years";

type MonthSelectorProps = CalendarSelectProps & {
  className?: string;
};

export const MonthSelector = ({
  className,
  displayMonth,
  minDate,
  maxDate,
  ...props
}: MonthSelectorProps) => {
  const commonProps = {
    displayMonth: utc(displayMonth),
    minDate: utc(minDate),
    maxDate: utc(maxDate),
    ...props
  };

  return (
    <div className={classNames(css.monthSelectorContainer, className)} role="gridcell">
      <Months {...commonProps} />
      <Years {...commonProps} />
    </div>
  );
};
